/* Customização: Store module para configurações da aplicação */
import ConfigAPI from '../../api/config';

export const state = {
  maxFileUploadSizeMB: 2048,
  maxFileUploadSizeBytes: 2048 * 1024 * 1024,
};

export const getters = {
  getMaxFileUploadSizeMB: state => state.maxFileUploadSizeMB,
  getMaxFileUploadSizeBytes: state => state.maxFileUploadSizeBytes,
};

export const actions = {
  async loadConfig({ commit }) {
    try {
      const response = await ConfigAPI.get();
      commit('SET_CONFIG', response.data);
    } catch (error) {
      console.error('Failed to load config:', error);
    }
  },
};

export const mutations = {
  SET_CONFIG(state, config) {
    state.maxFileUploadSizeMB = config.max_file_upload_size_mb;
    state.maxFileUploadSizeBytes = config.max_file_upload_size_bytes;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
